import { takeLatest, call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { ErrorUtils } from 'utils';
import { addErrorMessage } from 'features/message/redux/action';
import { loadingSubscriptionPlansAction, requestGetSubscriptionPlansAction } from 'features/subscription/redux/action';
import { getAllPlansData } from 'features/subscription/api';
import { PlansData } from 'features/subscription/ts/SubscriptionPlans';

function* subscriptionPlansRequestSaga() {
  yield put(loadingSubscriptionPlansAction(true));
  try {
    const { data } = (yield call(getAllPlansData)) as AxiosResponse<PlansData[]>;
    yield put(requestGetSubscriptionPlansAction(data));
  } catch (error) {
    const message = ErrorUtils.convertError(error);
    yield put(addErrorMessage(message));
  }
  yield put(loadingSubscriptionPlansAction(false));
}

function* subscriptionSaga() {
  yield takeLatest('GET_PLANS_DETAILS', subscriptionPlansRequestSaga);
}

export default subscriptionSaga;
